import ApplicationLogo from '../Components/ApplicationLogo';
import { Link } from '@inertiajs/react';

export default function Guest({ children, company }) {
    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="d-flex justify-content-center">
                        <Link href="/login">
                            <ApplicationLogo company={company} />
                        </Link>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}
